// extracted by mini-css-extract-plugin
module.exports = {"small":"Icons_small__2Juee","normal":"Icons_normal__2oDqb","large":"Icons_large__34iPv"};